module.exports = __webpack_public_path__ + "static/media/filter-gender-all.b6d5cebe.svg";